namespace GeniuzPOS.CustomReport {
    export namespace ReportCusSaleComparisonService {
        export const baseUrl = 'CustomReport/ReportCusSaleComparison';

        export declare function Create(request: Serenity.SaveRequest<ReportCusSaleComparisonRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportCusSaleComparisonRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportCusSaleComparisonRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportCusSaleComparisonRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CustomReport/ReportCusSaleComparison/Create",
            Update = "CustomReport/ReportCusSaleComparison/Update",
            Delete = "CustomReport/ReportCusSaleComparison/Delete",
            Retrieve = "CustomReport/ReportCusSaleComparison/Retrieve",
            List = "CustomReport/ReportCusSaleComparison/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportCusSaleComparisonService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
